/*
 * @Descripttion: 我的发票页
 * @Author: cb4786
 * @Date: 2023-08-10 16:59:12
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-04 09:48:15
 */

import UseMyInvoiceHook from './hooks'
import Styles from './styles.module.scss'
import { Row, Space, Tooltip } from 'antd'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import { invoiceState } from '../../components/SearchFilter/TemplateData'
import { GetLocalStorage, orderTypeData } from '../../tools/util'
import { formName } from '../../components/SearchFilter/formItem'
import { Collist } from '../../components/TableAntd/hook'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { invoiceNatureEnum } from '@/global/enum'

const MyInvoice = () => {
  const {
    pages,
    dataSource,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
    delMyInvoice,
  } = UseMyInvoiceHook()

  const invoiceStateRender = (text: string, record: any) => {
    const state = invoiceState.find((item) => item.code === text)?.name
    return (
      <div>
        {state}
        {state === '暂存' || state === '驳回' ? (
          <span
            className="btn-danger"
            style={{
              marginLeft: '12px',
              cursor: 'pointer',
              userSelect: 'none',
            }}
            onClick={() => {
              delMyInvoice(record)
            }}
          >
            删除
          </span>
        ) : (
          ''
        )}
      </div>
    )
  }

  // 表头数据
  const columns = [
    {
      key: 'invoiceNums',
      dataIndex: 'invoiceNums',
      title: '发票号',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text ? text : '暂无发票'}
        </span>
      ),
    },
    {
      key: 'invoiceNature',
      dataIndex: 'invoiceNature',
      title: '发票性质',
      render: (text: string) =>
        invoiceNatureEnum.getLabelByValue(text as any) || '-',
    },
    {
      key: 'orderSource',
      dataIndex: 'orderSource',
      title: '源单类型',
      render: (text: string) =>
        orderTypeData.find((item) => item.code === text)?.name,
    },
    {
      key: 'orderNos',
      dataIndex: 'orderNos',
      title: '客户订单号',
      render: (text: string) => text || '-',
    },
    {
      key: 'returnOrderNos',
      dataIndex: 'returnOrderNos',
      title: '退货单',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
      render: (text: string) => text || '-',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'orderCodes',
      dataIndex: 'orderCodes',
      title: '采购订单号',
      render: (text: string) => text || '-',
    },
    {
      key: 'invoiceState',
      dataIndex: 'invoiceState',
      title: '发票单状态',
      render: invoiceStateRender,
    },
    {
      key: 'invoiceAmount',
      dataIndex: 'invoiceAmount',
      title: '发票价税合计',
    },
    {
      key: 'orderAmount',
      dataIndex: 'orderAmount',
      title: '单据价税合计',
    },
  ]

  // 搜索条件
  const fieldsDataList: formName[] = [
    'invoiceNum',
    'invoiceNature',
    'orderSource',
    'orderNo',
    'returnOrderNo',
    'platform',
    'supplierOrderCode',
    'invoiceState',
  ]

  // 过滤展示表头和搜索条件
  const filterColumnsAndFieldsData = () => {
    let filterColumn: Collist[] = [...columns]
    let fieldsData: formName[] = [...fieldsDataList]
    // 供应商表头、搜索条件不展示源单类型、客户订单号、下单平台
    if (GetLocalStorage('COOPERATETYPE') === '1') {
      fieldsData = fieldsDataList.filter(
        (item) => !['orderSource', 'orderNo', 'platform'].includes(item),
      )
      filterColumn = columns.filter(
        (item) => !['orderSource', 'orderNos', 'platform'].includes(item.key),
      )
      // 电商供应商表头、搜索条件不展示源单类型、采购订单号
    } else if (GetLocalStorage('COOPERATETYPE') === '2') {
      fieldsData = fieldsDataList.filter(
        (item) => !['orderSource', 'supplierOrderCode'].includes(item),
      )
      filterColumn = columns.filter(
        (item) => !['orderSource', 'orderCodes'].includes(item.key),
      )
    }
    // 既是供应商又是电商供应商，表头和搜索条件全部展示
    return { filterColumn, fieldsData }
  }

  const { filterColumn, fieldsData } = filterColumnsAndFieldsData()

  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={fieldsData}
        onSearch={handleSearchClick}
        keyName="MYINVOICE"
        ScreenKey="MYINVOICE"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={filterColumn}
        loading={dataSource.loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}

export default MyInvoice
/*
 * @Descripttion: 我的发票页
 * @Author: cb4786
 * @Date: 2023-08-10 16:59:12
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-04 09:48:15
 */

import UseMyInvoiceHook from './hooks'
import Styles from './styles.module.scss'
import { Row, Space, Tooltip } from 'antd'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import { invoiceState } from '../../components/SearchFilter/TemplateData'
import { GetLocalStorage, orderTypeData } from '../../tools/util'
import { formName } from '../../components/SearchFilter/formItem'
import { Collist } from '../../components/TableAntd/hook'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { invoiceNatureEnum } from '@/global/enum'

const MyInvoice = () => {
  const {
    pages,
    dataSource,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
    delMyInvoice,
  } = UseMyInvoiceHook()

  const invoiceStateRender = (text: string, record: any) => {
    const state = invoiceState.find((item) => item.code === text)?.name
    return (
      <div>
        {state}
        {state === '暂存' || state === '驳回' ? (
          <span
            className="btn-danger"
            style={{
              marginLeft: '12px',
              cursor: 'pointer',
              userSelect: 'none',
            }}
            onClick={() => {
              delMyInvoice(record)
            }}
          >
            删除
          </span>
        ) : (
          ''
        )}
      </div>
    )
  }

  // 表头数据
  const columns = [
    {
      key: 'invoiceNums',
      dataIndex: 'invoiceNums',
      title: '发票号',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text ? text : '暂无发票'}
        </span>
      ),
    },
    {
      key: 'invoiceNature',
      dataIndex: 'invoiceNature',
      title: '发票性质',
      render: (text: string) =>
        invoiceNatureEnum.getLabelByValue(text as any) || '-',
    },
    {
      key: 'orderSource',
      dataIndex: 'orderSource',
      title: '源单类型',
      render: (text: string) =>
        orderTypeData.find((item) => item.code === text)?.name,
    },
    {
      key: 'orderNos',
      dataIndex: 'orderNos',
      title: '客户订单号',
      render: (text: string) => text || '-',
    },
    {
      key: 'returnOrderNos',
      dataIndex: 'returnOrderNos',
      title: '退货单',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
      render: (text: string) => text || '-',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'orderCodes',
      dataIndex: 'orderCodes',
      title: '采购订单号',
      render: (text: string) => text || '-',
    },
    {
      key: 'invoiceState',
      dataIndex: 'invoiceState',
      title: '发票单状态',
      render: invoiceStateRender,
    },
    {
      key: 'invoiceAmount',
      dataIndex: 'invoiceAmount',
      title: '发票价税合计',
    },
    {
      key: 'orderAmount',
      dataIndex: 'orderAmount',
      title: '单据价税合计',
    },
  ]

  // 搜索条件
  const fieldsDataList: formName[] = [
    'invoiceNum',
    'invoiceNature',
    'orderSource',
    'orderNo',
    'returnOrderNo',
    'platform',
    'supplierOrderCode',
    'invoiceState',
  ]

  // 过滤展示表头和搜索条件
  const filterColumnsAndFieldsData = () => {
    let filterColumn: Collist[] = [...columns]
    let fieldsData: formName[] = [...fieldsDataList]
    // 供应商表头、搜索条件不展示源单类型、客户订单号、下单平台
    if (GetLocalStorage('COOPERATETYPE') === '1') {
      fieldsData = fieldsDataList.filter(
        (item) => !['orderSource', 'orderNo', 'platform'].includes(item),
      )
      filterColumn = columns.filter(
        (item) => !['orderSource', 'orderNos', 'platform'].includes(item.key),
      )
      // 电商供应商表头、搜索条件不展示源单类型、采购订单号
    } else if (GetLocalStorage('COOPERATETYPE') === '2') {
      fieldsData = fieldsDataList.filter(
        (item) => !['orderSource', 'supplierOrderCode'].includes(item),
      )
      filterColumn = columns.filter(
        (item) => !['orderSource', 'orderCodes'].includes(item.key),
      )
    }
    // 既是供应商又是电商供应商，表头和搜索条件全部展示
    return { filterColumn, fieldsData }
  }

  const { filterColumn, fieldsData } = filterColumnsAndFieldsData()

  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={fieldsData}
        onSearch={handleSearchClick}
        keyName="MYINVOICE"
        ScreenKey="MYINVOICE"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={filterColumn}
        loading={dataSource.loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}

export default MyInvoice
